import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router'; // RouterModule,
import { MatDialogModule } from '@angular/material';
import { MAT_DATE_LOCALE} from '@angular/material/core'; // DateAdapter, MAT_DATE_FORMATS,

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { Push } from '@ionic-native/push/ngx';
import { Device } from '@ionic-native/device/ngx';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { AppVersion } from '@ionic-native/app-version/ngx';
// import { InAppPurchase } from '@ionic-native/in-app-purchase/ngx';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SettingService } from './services/setting.service';
import { EventService } from './services/event.service';
import { AuthService } from './services/auth.service';
import { AuthGuardService } from './services/auth-guard.service';
import { SocketService } from './services/socket.service';

import { RestHttpClientModule } from 'ng-rest-http';
import { HttpService } from './services/http.service';

import { CommonService } from './services/common.service';
import { ToasterModule } from './services/toaster.service';
import { DialogService } from './services/dialog.service';
import { PushService } from './services/push.service';
import { GameService } from './services/game.service';
import { PatternService } from './services/pattern.service';
import { PlatformService } from './services/platform.service';
import { FriendService } from './services/friend.service';
import { TimerService } from './services/timer.service';
import { ChatService } from './services/chat.service';
import { PopOverModule } from './pages/common/popover';
import { FooterModule } from './components/footer';

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    IonicModule.forRoot(),
    AppRoutingModule,
    MatDialogModule,
    BrowserAnimationsModule,
    RestHttpClientModule,
    FooterModule,
    ToasterModule,
    PopOverModule
    ],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: MAT_DATE_LOCALE, useValue: 'ko-KR'},
    Push, PushService,
    Device,
    InAppBrowser,
//    InAppPurchase,
    AppVersion,
    SocketService,
    SettingService,
    AuthService,
    AuthGuardService,
    DialogService,
    ChatService,
    CommonService,

    HttpService,
    EventService,
    FriendService,
    GameService,
    PatternService,
    PlatformService,
    TimerService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
